var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{attrs:{"cols":_vm.cols,"rows":_vm.rows,"auto-width":_vm.autoWidth,"pagination":_vm.pagination,"language":_vm.language,"height":'340px'}})}
var staticRenderFns = []

export { render, staticRenderFns }